import React, { Component } from "react";
import PropTypes from "prop-types";
import ResultsGroup from "../ResultsGroup";

export class RoomsResultsGroup extends Component {
  state = {
    rooms: []
  };

  componentDidMount() {
    const { getAnalyticsPlaceHolders } = this.props;
    this.setResults();
    this.props.onLoad();
    getAnalyticsPlaceHolders && getAnalyticsPlaceHolders();
  }

  componentDidUpdate(prevProps) {
    const { results } = this.props;
    if (results != prevProps.results) {
      this.setResults();
    }
  }

  componentWillUnmount() {
    const { clearAnalyticsPlaceHolders } = this.props;
    clearAnalyticsPlaceHolders && clearAnalyticsPlaceHolders();
  }

  setResults = () => {
    const { results: rooms } = this.props;
    let results = rooms;

    results = results.sort((r1, r2) => {
      return r1.sortOrder - r2.sortOrder || r1.lowestPrice - r2.lowestPrice;
    });

    this.setState({ rooms: results });
  };

  /// normal room object model to an acceptable thumbnail object
  normalizeRoom = room => {
    const normalizedRoom = {
      id: room.id,
      name: room.name,
      lowestPrice: room.lowestPrice,
      currency: room.currency,
      currencyCode: room.currencyCode,
      simpleClubTotalPrice: room.simpleClubLowestPrice,
      description: room.description,
      images: room.images,
      defaultImage: room.defaultImageUrl,
      requestedRoom: room.requestedRoom
    };
    return normalizedRoom;
  };

  render() {
    const {
      isRtl,
      titles,
      isMobileView,
      onRoomResultClick,
      onShowRoomDetailsClick,
      renderMarkup,
      isIos,
      showPricePerNightThumb,
      checkinDate,
      checkoutDate,
      clubUserLoggedIn,
      discountClubConfig,
      isPromoCodeValid
    } = this.props;

    const { rooms } = this.state;

    return (
      <ResultsGroup
        isRtl={isRtl}
        isMobileView={isMobileView}
        titles={titles}
        onResultClick={onRoomResultClick}
        onShowDetailsClick={onShowRoomDetailsClick}
        results={rooms}
        normalizeResult={this.normalizeRoom}
        renderMarkup={renderMarkup}
        isIos={isIos}
        showPricePerNightThumb={showPricePerNightThumb}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        clubUserLoggedIn={clubUserLoggedIn}
        discountClubConfig={discountClubConfig}
        isPromoCodeValid={isPromoCodeValid}
      />
    );
  }
}

RoomsResultsGroup.defaultProps = {
  isRtl: false,
  isMobileView: false,
  titles: {},
  results: [],
  onShowRoomDetailsClick: () => {},
  onRoomResultClick: () => {},
  onLoad: () => {}
};

RoomsResultsGroup.propTypes = {
  isRtl: PropTypes.bool,
  isMobileView: PropTypes.bool,
  titles: PropTypes.object,
  results: PropTypes.array,
  onRoomResultClick: PropTypes.func,
  onShowRoomDetailsClick: PropTypes.func,
  isIos: PropTypes.bool,
  onLoad: PropTypes.func,
  renderMarkup: PropTypes.func,
  getAnalyticsPlaceHolders: PropTypes.func,
  clearAnalyticsPlaceHolders: PropTypes.func,
  showPricePerNightThumb: PropTypes.bool,
  checkoutDate: PropTypes.string,
  checkinDate: PropTypes.string,
  clubUserLoggedIn: PropTypes.bool,
  isPromoCodeValid: PropTypes.bools
};

export default RoomsResultsGroup;



// WEBPACK FOOTER //
// ./src/components/RoomsResultsGroup/RoomsResultsGroup.js